/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartArea100S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2H2v20.224h20V2zM4 7.658V4h16v4.143L16.071 5 7.99 10.052 4 7.658zm11.929-.21L20 10.705v4.438L16.071 12 7.99 17.052 4 14.658V9.99l4.01 2.407 7.919-4.95z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartArea100S as ChartArea100S };
